<template>
  <el-dialog :title="activeItem.id
?'编辑信息':'添加信息'"
    :visible.sync="$parent.dialogVisible"
    width="30%">
    <el-form label-position="right"
      label-width="80px"
      :model="form"
      :rules="rules"
      ref="ruleForm">
      <el-form-item label="节点日期"
        prop="time">
        <el-date-picker v-model="form.time"
          type="date"
          :clearable="false"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="历程标题"
        prop="title">
        <el-input v-model="form.title"
          maxlength="40"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="历程内容"
        prop="content">
        <el-input type="textarea"
          v-model="form.content"
          resize="none"
          rows="7"
          maxlength="200"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.dialogVisible = false">取 消</el-button>
      <el-button type="primary"
        @click="submit('ruleForm')"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        time: new Date(),
        title: "",
        content: "",
      },
      rules: {
        time: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        title: [
          { required: true, message: "历程标题不能为空" },
          { whitespace: true, message: "历程标题不能为空" },
          { min: 1, max: 40, message: "请输入不超过 40 个字", trigger: "blur" },
        ],
        content: [
          { required: true, message: "历程内容不能为空" },
          { whitespace: true, message: "历程内容不能为空" },
          {
            min: 1,
            max: 200,
            message: "请输入不超过 200 个字",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
    };
  },

  methods: {
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let obj = {
            id: this.activeItem.id ?? null,
            time: dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.form.time)),
            title: this.form.title,
            content: this.form.content,
          };
          this.$emit("handleSubmit", obj);
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.activeItem.id) {
      this.form.time = new Date(this.activeItem.time);
      this.form.title = this.activeItem.title;
      this.form.content = this.activeItem.content;
    }
  },
};
</script>

<style>
</style>